/**
 * @generated SignedSource<<41285538122e3106ae8b14d17f94afcf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary" | "WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary" | "WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary" | "WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary" | "WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary" | "WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary">;
  readonly " $fragmentType": "WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary";
};
export type WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary$key = {
  readonly " $data"?: WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary"
    }
  ],
  "type": "IntegrationTurnpikeSummary",
  "abstractKey": null
};

(node as any).hash = "3b5a9545e922dd4a71ef609cf71d55cd";

export default node;
